module.exports = __webpack_public_path__ + "static/img/top-banner1-t.514e776.png";


//////////////////
// WEBPACK FOOTER
// ./static/home/top-banner1-t.png
// module id = 50od
// module chunks = 1